import * as yup from 'yup';
import { TenantsMessages } from '../Tenants.messages';
import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IntlShape } from 'react-intl';

type UseTenantForm = (intl: IntlShape) => UseFormReturn;

export const useTenantForm: UseTenantForm = (intl) => {
  const tenantValidationSchema = yup.object().shape({
    name: yup.string().required(intl.formatMessage(TenantsMessages.nameRequiredError)).min(2),
    alias: yup
      .string()
      .required(intl.formatMessage(TenantsMessages.aliasRequiredError))
      .min(2)
      .matches(
        /^(?!hii)[a-z0-9.-]{2,20}$/,
        'Tenant alias must be 2-20 chars long, consisting of letters, digits, hyphens, begin with a letter and must not start with `hii`',
      ),
    adminUser: yup
      .string()
      .required(intl.formatMessage(TenantsMessages.adminEmailRequiredError))
      .matches(
        /^hiiretail@[a-z0-9.-]+\.[a-z]{2,}$/,
        'Administrator email  must adhere to the naming convention of hiiretail@<tenant-domain-name>',
      ),
  });

  return useForm({
    resolver: yupResolver(tenantValidationSchema),
    mode: 'onChange',
  });
};
